import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getApiUrl } from "./config/api";

const API_BASE_URL = getApiUrl();

// 👉 Put your image URLs here
const LOGO_URL = "";        // GeoTrack logo (square)
const HERO_IMAGE_URL = "";  // Left-side background (night city map with route)
const SUPPORT_URL = "mailto:support@yourcompany.com";

// Floating activity cards on the left panel (set to [] if your hero image already has them)
const ACTIVITY_CARDS = [
  { title: "Client Meeting", time: "10:24 AM", avatar: "", style: { left: "74%", top: "51%" } },
  { title: "On Route", time: "01:15 PM", avatar: "", style: { left: "65%", top: "70%" } },
  { title: "Visit Completed", time: "04:32 PM", avatar: "", style: { left: "30%", top: "83%" } },
];

/* ---------- Icons (inline, no extra dependency) ---------- */
const Icon = {
  Mail: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </svg>
  ),
  Lock: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="4" y="11" width="16" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
      <circle cx="12" cy="16" r="1" fill="currentColor" />
    </svg>
  ),
  Eye: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  EyeOff: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M10.6 5.1A10.9 10.9 0 0 1 12 5c6.5 0 10 7 10 7a17.6 17.6 0 0 1-3.2 4.1M6.6 6.6C3.7 8.5 2 12 2 12s3.5 7 10 7a9.7 9.7 0 0 0 5.4-1.6" />
      <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
      <path d="m2 2 20 20" />
    </svg>
  ),
  Arrow: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  ),
  Shield: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6l-8-3Z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  ),
  Pin: (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
      <path d="M12 2a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5Z" />
    </svg>
  ),
  Users: (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
      <circle cx="12" cy="7.5" r="3.2" />
      <circle cx="5.5" cy="9" r="2.4" />
      <circle cx="18.5" cy="9" r="2.4" />
      <path d="M12 12.5c-3.6 0-6 2-6 4.5V19h12v-2c0-2.5-2.4-4.5-6-4.5ZM5 13.2c-2.2.3-4 1.7-4 3.6V19h3.5v-2c0-1.4.6-2.7 1.6-3.7-.4-.1-.7-.1-1.1-.1ZM19 13.2c-.4 0-.7 0-1.1.1 1 1 1.6 2.300 1.6 3.7v2H23v-2.2c0-1.9-1.8-3.3-4-3.6Z" />
    </svg>
  ),
  Chart: (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
      <rect x="4" y="13" width="4" height="7" rx="1" />
      <rect x="10" y="9" width="4" height="11" rx="1" />
      <rect x="16" y="4" width="4" height="16" rx="1" />
    </svg>
  ),
  Chevron: (p) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="m9 6 6 6-6 6" />
    </svg>
  ),
};

const FEATURES = [
  { label: ["Live GPS", "Tracking"], icon: Icon.Pin, box: "border-blue-500/60 bg-blue-600/20", color: "text-blue-400" },
  { label: ["Customer", "Management"], icon: Icon.Users, box: "border-emerald-500/60 bg-emerald-600/20", color: "text-emerald-400" },
  { label: ["Tally Prime", "Integration"], icon: Icon.Chart, box: "border-indigo-500/60 bg-indigo-600/20", color: "text-indigo-400" },
];

function Logo({ className = "" }) {
  return (
    <div className={`flex items-center justify-center rounded-2xl bg-white shadow-[0_0_40px_rgba(56,189,248,0.35)] ${className}`}>
      {LOGO_URL ? (
        <img src={LOGO_URL} alt="GeoTrack" className="h-full w-full object-contain p-2" />
      ) : (
        <span className="text-xl font-extrabold text-blue-800">GeoTrack</span>
      )}
    </div>
  );
}

export default function AdminLogin() {
  const [email, setEmail] = useState(() => localStorage.getItem("rememberedEmail") || "");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await fetch(`${API_BASE_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      let data;
      try {
        data = await res.json();
      } catch {
        throw new Error("Server returned an invalid response. Please try again.");
      }

      if (!res.ok) {
        if (data.error === "MissingFields") {
          throw new Error("Please enter both email and password.");
        }
        if (data.error === "InvalidCredentials") {
          throw new Error("Invalid email or password. Please check your credentials.");
        }
        if (data.error === "NoCompanyAssigned") {
          throw new Error("Your account is not assigned to any company. Contact super admin.");
        }
        if (data.error === "COMPANY_DEACTIVATED") {
          throw new Error(data.message || "Your company account has been deactivated. Contact support.");
        }
        if (data.error === "NO_LICENSE") {
          throw new Error(data.message || "Your company does not have an active license. Please purchase one.");
        }
        if (data.error === "LICENSE_EXPIRED") {
          throw new Error(data.message || "Your company license has expired. Please renew to regain access.");
        }
        throw new Error(data.message || `Login failed (${data.error || res.status}). Please try again.`);
      }

      const { token, user } = data;

      // Decode token to check admin status and company info
      const payload = JSON.parse(atob(token.split(".")[1]));

      // ✅ Check if user is admin OR super admin
      if (!payload.isAdmin && !payload.isSuperAdmin) {
        throw new Error("You are not authorized to access the admin dashboard.");
      }

      // ✅ Remember email for next visit
      if (rememberMe) {
        localStorage.setItem("rememberedEmail", email);
      } else {
        localStorage.removeItem("rememberedEmail");
      }

      // ✅ Store additional company context
      localStorage.setItem("token", token);
      localStorage.setItem("userEmail", user.email);
      localStorage.setItem("userName", user.fullName || "");
      localStorage.setItem("isAdmin", user.isAdmin ? "true" : "false");
      localStorage.setItem("isSuperAdmin", user.isSuperAdmin ? "true" : "false");
      localStorage.setItem("companyId", user.companyId || "");
      localStorage.setItem("companyName", user.companyName || "");
      localStorage.setItem("companySubdomain", user.companySubdomain || "");

      window.location.href = "/dashboard";
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  };

  return (
    <div className="flex min-h-screen w-full bg-[#f3f6fb] font-sans">
      {/* ================= LEFT: Brand / Hero ================= */}
      <aside
        className="relative hidden w-1/2 overflow-hidden bg-[#06142b] bg-cover bg-center lg:flex lg:flex-col"
        style={HERO_IMAGE_URL ? { backgroundImage: `url(${HERO_IMAGE_URL})` } : undefined}
      >
        {/* Darkening overlay so text stays readable */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#06142b]/95 via-[#06142b]/60 to-[#06142b]/30" />

        {/* Floating activity cards */}
        {ACTIVITY_CARDS.map((card) => (
          <div
            key={card.title}
            className="absolute z-10 hidden items-center gap-3 rounded-xl border border-sky-400/50 bg-[#071a36]/85 px-3 py-2.5 shadow-[0_0_24px_rgba(56,189,248,0.25)] backdrop-blur-sm xl:flex"
            style={card.style}
          >
            {card.avatar ? (
              <img src={card.avatar} alt="" className="h-8 w-8 rounded-full object-cover ring-2 ring-white/80" />
            ) : (
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-slate-200 text-xs font-bold text-slate-700 ring-2 ring-white/80">
                {card.title.charAt(0)}
              </div>
            )}
            <div className="leading-tight">
              <p className="text-[11px] font-semibold text-white">{card.title}</p>
              <p className="text-[11px] text-slate-300">{card.time}</p>
            </div>
            <Icon.Chevron className="ml-2 h-4 w-4 text-slate-300" />
          </div>
        ))}

        <div className="relative z-10 flex h-full flex-col px-14 pb-10 pt-10">
          {/* Top row: logo + tagline */}
          <div className="flex items-start justify-between">
            <Logo className="h-[108px] w-[128px]" />
            <div className="mt-3 flex items-center gap-3">
              <span className="h-px w-8 bg-sky-400" />
              <span className="text-[10px] font-medium uppercase tracking-[0.25em] text-slate-300">
                Field Sales Intelligence
              </span>
            </div>
          </div>

          {/* Headline */}
          <h1 className="mt-7 text-[44px] font-extrabold leading-[1.08] tracking-tight text-white xl:text-[52px]">
            Every field visit.
            

            <span className="text-sky-400">Every opportunity.</span>
          </h1>
          <p className="mt-4 max-w-md text-lg leading-snug text-slate-200 xl:text-xl">
            Real-time visibility for your field team, customers, and sales operations.
          </p>

          {/* Feature tiles */}
          <div className="mt-8 flex gap-16">
            {FEATURES.map(({ label, icon: FeatureIcon, box, color }) => (
              <div key={label[0]}>
                <div className={`flex h-[54px] w-[54px] items-center justify-center rounded-lg border ${box}`}>
                  <FeatureIcon className={`h-6 w-6 ${color}`} />
                </div>
                <p className="mt-3 text-sm font-semibold leading-snug text-white">
                  {label[0]}
                  

                  {label[1]}
                </p>
              </div>
            ))}
          </div>

          {/* Footer tagline */}
          <div className="mt-auto flex items-center gap-4">
            <span className="h-1 w-9 rounded-full bg-sky-400" />
            <span className="text-xs text-slate-300">Built for teams that move business forward.</span>
          </div>
        </div>
      </aside>

      {/* ================= RIGHT: Login form ================= */}
      <main className="relative flex w-full items-center justify-center px-4 py-10 lg:w-1/2">
        {/* subtle background */}
        <div
          className="pointer-events-none absolute inset-0 opacity-60"
          style={{
            backgroundImage:
              "radial-gradient(circle at 85% 10%, rgba(148,163,184,0.12) 0, transparent 40%), radial-gradient(circle at 10% 90%, rgba(148,163,184,0.10) 0, transparent 40%)",
          }}
        />

        <div className="relative w-full max-w-[470px]">
          {/* Logo on small screens (left panel hidden) */}
          <div className="mb-6 flex justify-center lg:hidden">
            <Logo className="h-20 w-24" />
          </div>

          <div className="rounded-2xl bg-white px-6 py-10 shadow-[0_10px_40px_rgba(15,23,42,0.08)] sm:px-9">
            <div className="text-center">
              <h2 className="text-[34px] font-extrabold tracking-tight text-slate-900">Welcome back</h2>
              <p className="mt-2 text-[15px] text-slate-500">Sign in to your GeoTrack admin account</p>
            </div>

            {error && (
              <div className="mt-6 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">
                {error}
              </div>
            )}

            <form onSubmit={handleLogin} className="mt-7 space-y-5" noValidate>
              {/* Email */}
              <div>
                <label htmlFor="email" className="mb-2 block text-[15px] font-medium text-slate-800">
                  Email address
                </label>
                <div className="relative">
                  <Icon.Mail className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-500" />
                  <input
                    id="email"
                    type="email"
                    autoComplete="email"
                    placeholder="you@company.com"
                    className="h-12 w-full rounded-lg border border-slate-200 bg-white pl-12 pr-4 text-[15px] text-slate-800 placeholder-slate-400 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 disabled:bg-slate-50"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                  />
                </div>
              </div>

              {/* Password */}
              <div>
                <label htmlFor="password" className="mb-2 block text-[15px] font-medium text-slate-800">
                  Password
                </label>
                <div className="relative">
                  <Icon.Lock className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-500" />
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="current-password"
                    placeholder="Enter your password"
                    className="h-12 w-full rounded-lg border border-slate-200 bg-white pl-12 pr-12 text-[15px] text-slate-800 placeholder-slate-400 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 disabled:bg-slate-50"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={loading}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((s) => !s)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 rounded p-1 text-slate-500 hover:text-slate-700"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? <Icon.EyeOff className="h-5 w-5" /> : <Icon.Eye className="h-5 w-5" />}
                  </button>
                </div>
              </div>

              {/* Remember + Forgot */}
              <div className="flex items-center justify-between">
                <label className="flex cursor-pointer select-none items-center gap-3 text-[15px] text-slate-700">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="h-5 w-5 cursor-pointer rounded accent-blue-600"
                  />
                  Remember me
                </label>
                <Link to="/forgot-password" className="text-[15px] font-medium text-blue-600 hover:text-blue-800">
                  Forgot password?
                </Link>
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={loading}
                className="flex h-[52px] w-full items-center justify-center gap-3 rounded-lg bg-gradient-to-r from-blue-600 to-blue-500 text-[17px] font-semibold text-white shadow-[0_8px_20px_rgba(37,99,235,0.3)] transition hover:from-blue-700 hover:to-blue-600 disabled:cursor-not-allowed disabled:opacity-60"
              >
                {loading ? (
                  <>
                    <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white" />
                    Signing in...
                  </>
                ) : (
                  <>
                    Sign in to dashboard
                    <Icon.Arrow className="h-5 w-5" />
                  </>
                )}
              </button>
            </form>

            {/* Secure note */}
            <div className="mt-6 flex items-center justify-center gap-2 text-sm text-slate-500">
              <Icon.Shield className="h-5 w-5 text-slate-600" />
              Secure access · Company assignment required
            </div>

            <hr className="my-6 border-slate-200" />

            <p className="text-center text-[15px] text-slate-600">
              Need help accessing your account?{" "}
              <a href={SUPPORT_URL} className="font-medium text-blue-600 underline underline-offset-2 hover:text-blue-800">
                Contact support
              </a>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
